export const ALLOWED_TEXT_PATTERN = /^[A-Za-z0-9\s,.'/-]+$/;
export const ALLOWED_NAME_PATTERN = /^[A-Za-z\s,.'-]+$/;
export const PHONE_PATTERN = /^[0-9+\s]+$/;

export const TEXT_VALIDATION_MSG =
  'Only letters, numbers, spaces, commas, full stops, hyphens, apostrophes, and forward slashes are allowed';
export const NAME_VALIDATION_MSG =
  'Only letters, spaces, commas, full stops, hyphens, and apostrophes are allowed';
export const PHONE_VALIDATION_MSG = 'Only numeric characters are allowed';
